import React from 'react';
import { X, TrashIcon } from 'lucide-react';
interface SavedCouponsProps {
  coupons: any[];
  onClose: () => void;
  onCouponClick: (coupon: any) => void;
  onRemove: (coupon: any) => void;
}
export function SavedCoupons({
  coupons,
  onClose,
  onCouponClick,
  onRemove
}: SavedCouponsProps) {
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-333">
      <div className="bg-white rounded-xl max-w-lg w-full max-h-[80vh] flex flex-col animate-fade-in" data-id="element-334">
        <div className="p-4 flex justify-between items-center border-b border-gray-200" data-id="element-335">
          <h3 className="font-bold text-lg" data-id="element-336">Saved Coupons</h3>
          <button className="p-1 rounded-full hover:bg-gray-100" onClick={onClose} data-id="element-337">
            <X size={20} className="text-black" data-id="element-338" />
          </button>
        </div>
        <div className="flex-grow overflow-y-auto p-4" data-id="element-339">
          {coupons.length === 0 ? <div className="text-center py-8" data-id="element-340">
              <p className="text-gray-500" data-id="element-341">
                You haven't saved any coupons yet.
              </p>
              <button className="mt-4 bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600 transition" onClick={onClose} data-id="element-342">
                Browse Coupons
              </button>
            </div> : <div className="space-y-3" data-id="element-343">
              {coupons.map(coupon => <div key={coupon.id} className="flex items-center bg-white border border-gray-200 rounded-lg p-3 hover:shadow-md transition" data-id="element-344">
                  {coupon.brand && <img src={`https://logo.clearbit.com/${coupon.brand.toLowerCase()}.com?size=40`} alt={coupon.brand} className="h-10 w-10 mr-3 object-contain" onError={e => {
              ;
              (e.target as HTMLImageElement).style.display = 'none';
            }} data-id="element-345" />}
                  <div className="flex-grow cursor-pointer" onClick={() => onCouponClick(coupon)} data-id="element-346">
                    <h4 className="font-medium" data-id="element-347">
                      {coupon.brand || coupon.title}
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-348">
                      {coupon.description || coupon.highlight && `${coupon.highlight} ${coupon.icon || ''}`}
                    </p>
                  </div>
                  <button className="p-2 text-gray-500 hover:text-red-500 hover:bg-red-50 rounded-full transition" onClick={() => onRemove(coupon)} data-id="element-349">
                    <TrashIcon size={18} className="text-black hover:text-red-500" data-id="element-350" />
                  </button>
                </div>)}
            </div>}
        </div>
      </div>
    </div>;
}